export default "__VITE_ASSET__BvoUX48e__"